import { render, staticRenderFns } from "./jifen.vue?vue&type=template&id=587eb108&scoped=true"
import script from "./jifen.vue?vue&type=script&lang=js"
export * from "./jifen.vue?vue&type=script&lang=js"
import style0 from "./jifen.vue?vue&type=style&index=0&id=587eb108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587eb108",
  null
  
)

export default component.exports